import { render, staticRenderFns } from "./PromoLabel.vue?vue&type=template&id=cf2f9854&scoped=true"
import script from "./PromoLabel.vue?vue&type=script&lang=js"
export * from "./PromoLabel.vue?vue&type=script&lang=js"
import style0 from "./PromoLabel.vue?vue&type=style&index=0&id=cf2f9854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2f9854",
  null
  
)

export default component.exports